import styles from '../../../style.module.scss';
import {getOffHoursNoticeText} from '../../../utils/work-time';

const OffHoursIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path
            d="M18.0968 14.7084L11.6459 3.05594C11.3097 2.44885 10.6947 2.08594 10.0005 2.08594C9.30634 2.08594 8.69134 2.44885 8.35509 3.05594L1.90426 14.7084C1.57801 15.298 1.58717 15.9959 1.92967 16.5764C2.27134 17.1564 2.87717 17.5026 3.55009 17.5026H16.4513C17.1238 17.5026 17.7297 17.1564 18.0718 16.5764C18.4134 15.9964 18.423 15.298 18.0968 14.7084ZM9.37551 7.29427C9.37551 6.94885 9.65551 6.66927 10.0005 6.66927C10.3455 6.66927 10.6255 6.94885 10.6255 7.29427V11.4609C10.6255 11.8064 10.3455 12.0859 10.0005 12.0859C9.65551 12.0859 9.37551 11.8064 9.37551 11.4609V7.29427ZM10.0005 15.0026C9.54009 15.0026 9.16717 14.6297 9.16717 14.1693C9.16717 13.7089 9.54009 13.3359 10.0005 13.3359C10.4609 13.3359 10.8338 13.7089 10.8338 14.1693C10.8338 14.6297 10.4609 15.0026 10.0005 15.0026Z"
            fill="#5695F6"
        />
    </svg>
);

const OffHoursNotice = ({workTime, lang = 'ru'}) => {
    return (
        <div className={styles.offHoursNotice}>
            <div className={styles.offHoursNotice__icon}>
                <OffHoursIcon/>
            </div>
            <div className={styles.offHoursNotice__text}>
                {getOffHoursNoticeText(workTime, lang)}
            </div>
        </div>
    );
};

export default OffHoursNotice;
